module.exports = __webpack_public_path__ + "img/portfolio3.dafa7fc6.svg";